import React, { memo } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import styles from './assets/styles/selectInput.styles'
import { useMediaQuery } from '@material-ui/core'
import dropDownIcon from './assets/images/moreIcon.svg'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import { handleChange } from '../app/formSlice'
import { useAppDispatch, useAppSelector } from '../app/hooks/reduxHooks'
const useStyles = makeStyles(styles)

function SelectInput({ label, menuItems, name }) {
    const classes = useStyles()
    const value = useAppSelector(state => state.form[name])
    const dispatch = useAppDispatch()
    const isMobile = useMediaQuery('(max-width: 760px)')
    const setValue = e => {
        dispatch(handleChange({
            name: e.target.name,
            value: e.target.value
        }))
    }
    return (
        <span className={classes.span} >
            <p className={classes.label} >{label} *</p>
            <Select
                name={name}
                fullWidth
                native={isMobile}
                MenuProps={{
                    disableScrollLock: true,
                    disableAutoFocusItem: true,
                    disableEnforceFocus: true,
                    disableRestoreFocus: true,
                    disableAutoFocus: true,
                    keepMounted: true,
                    disablePortal: true,
                    MenuListProps: {
                        disablePadding: true
                    }
                }}
                onChange={setValue}
                value={value}
                classes={{ focused: classes.focused }}
                defaultValue={menuItems[0]}
                inputProps={{
                    className: classes.input
                }}
                disableUnderline
                IconComponent={() => <img className={classes.icon} src={dropDownIcon} alt='drop down' />}
            >
                {menuItems.map((e, i) => <MenuItem
                    key={i}
                    className={classes.menuItem}
                    value={e.replace(/\s+/g, '')}
                    classes={{ selected: classes.menuSelected }}
                >{e}
                </MenuItem>
                )}
                {isMobile && menuItems.map((e, i) =>
                    <option
                        key={i}
                        value={e.replace(/\s+/g, '')}
                    >
                        {e}
                    </option>)}
            </Select>
        </span>
    )
}

export default memo(SelectInput)